import { render, staticRenderFns } from "./FacilityForm.vue?vue&type=template&id=56733d30&scoped=true"
import script from "./FacilityForm.vue?vue&type=script&lang=js"
export * from "./FacilityForm.vue?vue&type=script&lang=js"
import style0 from "./FacilityForm.vue?vue&type=style&index=0&id=56733d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56733d30",
  null
  
)

export default component.exports